import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import _ from "lodash";
import FunctionalCollapse from "components/common/FunctionalCollapse";
import TopBar from "components/schedule/EditDraftSchedule/Topbar";
import StoreTable from "components/schedule/EditDraftSchedule/StoreTable";
import JobTable from "components/schedule/EditDraftSchedule/JobTable";

import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";

import {
    fetchDraft,
    clearDrafts
} from "actions/draftActions";

const AddStoreModal = React.lazy(() =>
    import("components/schedule/EditDraftSchedule/AddStoreModal/modal"));
const AddJobModal = React.lazy(() =>
    import("components/schedule/EditDraftSchedule/AddJobModal/modal"));

class EditDraftSchedule extends React.Component {
    readOnlyStatusArr = ["Complete", "Exported"];

    constructor(props) {
        super(props);

        this.handleAddStore = this.handleAddStore.bind(this);
        this.handleAddJob = this.handleAddJob.bind(this);
    }

    componentDidMount() {
        this.props.fetchDraft(this.props.match.params.id);
    }

    componentWillUnmount() {
        this.props.clearDrafts();
    }

    onSubmit = formValues => {
        this.props.editDraft(this.props.match.params.id, formValues);
    };

    handleAddStore (event) {
        event.stopPropagation();
        const { draft } = this.props;
        const excludeStoresIdArray = Array.isArray(draft.draftStores)
            ? _.uniq(draft.draftStores.map(value => value.storeId))
            : [];

        const modalObj = {
            id: "add-stores",
            modalSettings: {
                size: "lg"
            },
            header: "Add Stores to draft",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <AddStoreModal
                        excludeStoresIdArray={excludeStoresIdArray}
                        handleHide={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    }

    handleAddJob (event) {
        event.stopPropagation();
        const { draft } = this.props;
        // jobProductId
        const excludeJobsIdArray = Array.isArray(draft.draftJobs)
            ? _.uniq(draft.draftJobs.map(value => value.jobProductId))
            : [];

        const modalObj = {
            id: "add-jobs",
            modalSettings: {
                size: "lg"
            },
            header: "Add Jobs to draft",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <AddJobModal
                        excludeJobsIdArray={excludeJobsIdArray}
                        handleHide={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    }

    render() {
        const {
            draft
        } = this.props;

        const storeTableHeader = `Stores (${draft.draftStores ? draft.draftStores.length : 0})`;
        const jobTableHeader = `Jobs (${draft.draftJobs ? draft.draftJobs.length : 0})`;

        const readOnly = this.readOnlyStatusArr.indexOf(draft.status) !== -1;


        return (
            <div>
                <h3 className="mb-4">Edit Draft Schedule</h3>
                <TopBar history={this.props.history}/>
                <br/>

                <div className='mb-5'>
                    <FunctionalCollapse
                        ButtonText="Add Stores"
                        header={storeTableHeader}
                        onClick={this.handleAddStore}
                        showButton={!readOnly}
                    >
                        <StoreTable readOnly={readOnly}/>
                    </FunctionalCollapse>
                </div>

                <div className=''>
                    <FunctionalCollapse
                        ButtonText="Add jobs"
                        header={jobTableHeader}
                        onClick={this.handleAddJob}
                        showButton={!readOnly}
                    >
                        <JobTable readOnly={readOnly}/>
                    </FunctionalCollapse>
                </div>
            </div>
        );
    }
}

EditDraftSchedule.propTypes = {
    fetchDraft: PropTypes.func.isRequired,
    clearDrafts: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    draft: state.draft.draft,
});

const mapStateToDispatch = dispatch => ({
    fetchDraft: bindActionCreators(fetchDraft, dispatch),
    clearDrafts: bindActionCreators(clearDrafts, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch,
)(EditDraftSchedule);
